import { appId } from "./Table_Configs";

import { pFetch } from "./helpers.js";
const realmHostname = process.env.REACT_APP_HOSTNAME;
const userAgent = process.env.REACT_APP_USER_AGENT;
const apptoken = process.env.REACT_APP_APP_TOKEN;

async function getAuthToken(dbid) {
  try {
    const response = await pFetch(
      `https://api.quickbase.com/v1/auth/temporary/${dbid ? dbid : appId}`,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "QB-Realm-Hostname": realmHostname,
          "User-Agent": userAgent,
          "QB-App-Token": apptoken,
          "Content-Type": "application/json",
        },
      },
    );

    if (!response.ok) {
      throw new Error("Failed to fetch auth token: " + response.statusText);
    }
    const data = await response.json(); // was JSON.parse()ing res.json();
    return data.temporaryAuthorization; /*Extract the token from the response*/
  } catch (error) {
    console.error("Error fetching auth token: " + error.message, "error");
    return null;
  }
}

export async function quickbaseFetch(url, options, retry = 2, timeout = 6000) {
  const origin = undefined;
  const contentType = options.headers && options.headers["Content-Type"];
  const isJsonApi = contentType && contentType.includes("application/json");
  const body = (options.body && isJsonApi) && JSON.parse(options.body);
  const dbid = body && body?.from ? body?.from : body?.to;
  const message = {
    type: "FETCH_REQUEST",
    url: url,
    options: {
      ...options,
      headers: {
        ...options?.headers,
        "Content-Type": options?.headers["Content-Type"] || "application/json",
      },
    },
    dbid: dbid ? dbid : appId, // Only needed for JSON API requests
  };

  const requestPromise = new Promise((resolve, reject) => {

    const handleResponse = (event) => {
      if (event.origin !== origin) {
        console.warn("Invalid origin:", event.origin);
        return;
      }

      const { type, status, statusText, body } =
        event.data;

      if (type === "FETCH_RESPONSE") { // && responseId === requestId) {
        if (status >= 200 && status < 300) {

          resolve({ status, statusText, body });
        } else {

          reject({ status, statusText, body });
        }
      }
    };

    fetchFetcher({ data: message }).then((res) => {
      handleResponse(res);
    });
  });

  return requestPromise;
}
async function fetchFetcher(event) {
  const { url, options, requestId, dbid } = event.data;

  try {
    const contentType = options.headers && options.headers["Content-Type"];
    const isJsonApi = contentType && contentType.includes("application/json");
    const isXmlApi = contentType && contentType.includes("application/xml");

    if (isJsonApi || isXmlApi) {
      let authToken = null;

      if (isJsonApi) {
        authToken = await getAuthToken(dbid);
        if (!authToken) {
          throw new Error("Authentication token not retrieved.");
        }
      }

      const fetchOptions = {
        ...options,
        headers: {
          ...options.headers,
          ...(isJsonApi
            ? { "Authorization": `QB-TEMP-TOKEN ${authToken}` }
            : {}), //{ 'Authorization': `QB-USER-TOKEN b5v58h_rerc_0_fm4aa9ctbsz8zdh649nur9marx` } : {})//{ 'Authorization': `QB-TEMP-TOKEN ${authToken}` } : {})//
        },
      };

      const response = await fetch(url, fetchOptions);
      const body = isXmlApi ? await response.text() : await response.json();

      return {
        data: {
          type: "FETCH_RESPONSE",
          requestId,
          status: response.status,
          statusText: response.statusText,
          body,
        },
      };
    } else {
      console.warn("Unsupported Content-Type: " + contentType, "warn");
    }
  } catch (error) {
    console.error("Request Error: " + error.message, "error");
    return ({
      data: {
        type: "FETCH_RESPONSE",
        requestId,
        status: 500,
        statusText: "Internal Server Error",
        body: error.message,
      },
    });
  }
}
